export const init = () => {

  // TRACKER 'MY PROFILE'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.profile);

  /*
	 * CUSTOMER DASHBOARD - MY PROFILE
	 */

  /*
	 * -- LOGIN + MOBILE
	 */
  // editLogin
  const editLogin = new AnalyticsClickEvent('editLogin', tracker.defaultEvent());
  editLogin.domContainer = '#profile-data';
  editLogin.domElement = '.js-edit-login .edit-button';
  editLogin.options.label = 'Login';
  tracker.addEvent(editLogin);

  // saveLogin
  const saveLogin = new AnalyticsQueueEvent('saveLogin', tracker.defaultEvent());
  saveLogin.trigger = 'click';
  saveLogin.domContainer = '#profile-data';
  saveLogin.domElement = '.js-edit-login .submit-button';
  saveLogin.options.label = 'Login Save';
  tracker.addEvent(saveLogin);

  // backLogin
  const backLogin = new AnalyticsClickEvent('backLogin', tracker.defaultEvent());
  backLogin.domContainer = '#profile-data';
  backLogin.domElement = '.js-edit-login .cancel-button';
  backLogin.options.label = 'Login Back';
  tracker.addEvent(backLogin);


  /*
	 * -- PASSWORD
	 */
  // editPassword
  const editPassword = new AnalyticsClickEvent('editPassword', tracker.defaultEvent());
  editPassword.domContainer = '#profile-data';
  editPassword.domElement = '.js-edit-password .edit-button';
  editPassword.options.label = 'Password';
  tracker.addEvent(editPassword);

  // savePassword
  const savePassword = new AnalyticsQueueEvent('savePassword', tracker.defaultEvent());
  savePassword.trigger = 'click';
  savePassword.domContainer = '#profile-data';
  savePassword.domElement = '.js-edit-password .submit-button';
  savePassword.options.label = 'Password Save';
  tracker.addEvent(savePassword);

  // backPassword
  const backPassword = new AnalyticsClickEvent('backPassword', tracker.defaultEvent());
  backPassword.domContainer = '#profile-data';
  backPassword.domElement = '.js-edit-password .cancel-button';
  backPassword.options.label = 'Password Back';
  tracker.addEvent(backPassword);

  /*
	 * -- HOME ADDRESS
	 */
  // editHomeAddress
  const editHomeAddress = new AnalyticsClickEvent('editHomeAddress', tracker.defaultEvent());
  editHomeAddress.domContainer = '#my-profile';
  editHomeAddress.domElement = '.js-edit-address .edit-button';
  editHomeAddress.options.label = 'HomeAddress';
  tracker.addEvent(editHomeAddress);

  // saveHomeAddress
  const saveHomeAddress = new AnalyticsQueueEvent('saveHomeAddress', tracker.defaultEvent());
  saveHomeAddress.trigger = 'click';
  saveHomeAddress.domContainer = '#my-profile';
  saveHomeAddress.domElement = '.js-edit-address .submit-button';
  saveHomeAddress.options.label = 'HomeAddress Save';
  tracker.addEvent(saveHomeAddress);

  // backHomeAddress
  const backHomeAddress = new AnalyticsClickEvent('backHomeAddress', tracker.defaultEvent());
  backHomeAddress.domContainer = '#my-profile';
  backHomeAddress.domElement = '.js-edit-address .cancel-button';
  backHomeAddress.options.label = 'HomeAddress Back';
  tracker.addEvent(backHomeAddress);


  /*
	 * -- PERSONAL INFORMATION
	 */
  // editInfoPerso
  const editInfoPerso = new AnalyticsClickEvent('editInfoPerso', tracker.defaultEvent());
  editInfoPerso.domContainer = '#profile-data';
  editInfoPerso.domElement = '.js-edit-info .edit-button';
  editInfoPerso.options.label = 'PersonalData';
  tracker.addEvent(editInfoPerso);

  // saveInfoPerso
  const saveInfoPerso = new AnalyticsQueueEvent('saveInfoPerso', tracker.defaultEvent());
  saveInfoPerso.trigger = 'click';
  saveInfoPerso.domContainer = '#profile-data';
  saveInfoPerso.domElement = '.js-edit-info .submit-button';
  saveInfoPerso.options.label = 'PersonalData Save';
  tracker.addEvent(saveInfoPerso);

  // backInfoPerso
  const backInfoPerso = new AnalyticsClickEvent('backInfoPerso', tracker.defaultEvent());
  backInfoPerso.domContainer = '#profile-data';
  backInfoPerso.domElement = '.js-edit-info .cancel-button';
  backInfoPerso.options.label = 'PersonalData Back';
  tracker.addEvent(backInfoPerso);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/profile-tracker.js